export default {
    title: "Mit Musik Malen",
    GAC_presents: "Google Arts & Culture präsentiert",
    about01:
        "„Mit Musik malen“ ist ein interaktives Erlebnis, bei dem zwei künstlerische Ausdrucksformen kombiniert werden: das Malen und die Musik.",
    about02: "Mithilfe einer Engine für maschinelles Lernen der",
    about03: "DDSP-Mediathek von Magenta",
    about04:
        "(Differentiable Digital Signal Processing) werden Ihre Pinselstriche in Musiknoten übersetzt, die von einem Instrument Ihrer Wahl gespielt werden.",
    about05:
        "Sie haben mehrere sensorische Leinwände zur Auswahl, vom Himmel bis zum Ozean. Dabei wird Ihre Komposition – passend zum jeweiligen Ambiente – mit besonderen Soundeffekten untermalt.",
    ok: "Ok",
    share_msg:
        "Mit Google Arts & Culture können Sie Ihren Pinsel in Musikinstrumente verwandeln.",
    change_atmosphere: "Leinwand wechseln",
    atmosphere_subtitle: "Wo möchten Sie mit Musik malen?",
    in_the_sky: "Am Himmel",
    underwater: "Unter Wasser",
    on_the_street: "Auf der Straße",
    on_paper: "Auf Papier",
    shared_welcome:
        "Sieh dir meine gemalte musikalische Komposition an – möglich gemacht durch maschinelles Lernen.",
    create_my_own: "Eigene Komposition erstellen",
    ios_message01: "Wenn Sie sich Ihre Komposition anhören möchten, öffnen Sie",
    ios_message02: "g.co/paintwithmusic",
    ios_message03: "auf dem Computer oder einem Android-Gerät.",
    share_your_masterpiece: "Lassen Sie die Welt an Ihrem Meisterwerk teilhaben.",
    try_other_instrument: "Probieren Sie es mit einem anderen Instrument.",
    loading_flute: "Flöte wird ausgepackt",
    loading_violin: "Geige wird gestimmt",
    loading_saxo: "Saxofon wird poliert",
    loading_trumpet: "Trompete wird angewärmt",
    loading_birds: "Vögel werden gerufen",
    loading_AI: "KI wird aufgeweckt",
    loading_whales: "Wale werden zusammengetrommelt",
    loadding_spray: "Sprühdosen werden geschüttelt",
    canvas_full: "Ihre Leinwand ist voll!",
    remove_items: "Wenn Sie weitermalen möchten, entfernen Sie ein paar Formen.",
    flute: "Flöte",
    violin: "Geige",
    saxophone: "Saxofon",
    trumpet: "Trompete",
    guitar: "Guitar",
    xylophone: "Xylophone",
    birds: "Vogel-Stempel",
    whale: "Wal-Stempel",
    scratch: "Kratzer-Stempel",
    yo: "Yo-Stempel",
    seal: "Stempel",
    toggle_grid: "Notenhinweise ausblenden",
    undo: "Rückgängig",
    clear_canvas: "Leinwand löschen",
    clear: "Löschen",
    back: "Zurück",
    turn_device: "Noch mehr Spaß macht es, wenn Sie Ihr Gerät drehen.",
    info_scale:
        "Das ist eine heptatonische Tonleiter. Eine Oktave besteht also aus sieben unterschiedlichen Tönen. Die bekanntesten heptatonischen Tonleitern sind die Dur- und die Moll-Tonleiter, die in der abendländischen Musik sehr verbreitet sind.",
    info_japanese_scale:
        "Das ist eine Hirajōshi-Tonleiter aus Japan. Die von Yatsuhashi Kengyō entwickelte Tonleiter basiert auf Shamisen-Musik und wurde ursprünglich verwendet, um die Koto – eine japanische Zither – zu stimmen.",
    atmosphere_warning_title: "Achtung!",
    atmosphere_warning_text: "Wenn Sie die Leinwand ändern, wird Ihr Bild zurückgesetzt.",
    safari_warning: "Noch mehr Spaß macht es, wenn Sie einen anderen Browser verwenden.",
    go_back: "Zurück",
    about: "Info",
    share: "Teilen",
    toggle_play_pause: "Abspielen/Pause",
    generating_shared_strokes: "Audiodatei erstellen",
};